// extracted by mini-css-extract-plugin
module.exports = {"inputSwitch":"InputSwitch_inputSwitch__c1mq4","toggle":"InputSwitch_toggle__E89ty","reversed":"InputSwitch_reversed__Jc_LQ"};